import { selectActiveType } from './selectActiveType';
import { IInfrastructureFeaturesMap } from '../../../common/types/infrastructure';
import { IMapState } from '../../types';

export function selectActiveInfrastructureFeatures(state: IMapState): IInfrastructureFeaturesMap {
  const activeLayer = selectActiveType(state);

  if (!activeLayer) {
    return {};
  }

  const layerData = state.map.infrastructure.data[activeLayer.id];

  return layerData?.features || {};
}
